import { render, staticRenderFns } from "./KnowledgeArticlesList.vue?vue&type=template&id=1d0c2fa0&scoped=true&"
import script from "./KnowledgeArticlesList.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeArticlesList.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeArticlesList.vue?vue&type=style&index=0&id=1d0c2fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0c2fa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
